<div [ngClass]="preview ? 'grid grid-cols-3 gap-3 mb-5 mt-5' : 'grid grid-cols-2 gap-3 mb-5 mt-5'">
  @if(posts$ | async; as posts) {
  @let visiblePosts = preview ? posts.slice(0, 3) : posts;
  @for(post of visiblePosts; track post.id) {
  <div class="w-full border border-gray-300">
    <img [src]="post.imageUrl" alt="post" loading="lazy" class="w-full h-40 sm:h-72 object-contain rounded-lg" />
  </div>
  } }
</div>